import { DEV } from "solid-js"
import { Vector3 } from "three"
import { freeze } from "../util/Object"
import { SQRT1_2 } from "../util/math/Math"

/** South direction vector (0, 0, -1) */
export const SOUTH_VECTOR3 = new Vector3(0, 0, 1)

/** South-East direction vector (√2/2, 0, -√2/2) */
export const SOUTH_EAST_VECTOR3 = new Vector3(SQRT1_2, 0, SQRT1_2)

/** East direction vector (1, 0, 0) */
export const EAST_VECTOR3 = new Vector3(1, 0, 0)

/** North-East direction vector (√2/2, 0, √2/2) */
export const NORTH_EAST_VECTOR3 = new Vector3(SQRT1_2, 0, -SQRT1_2)

/** North direction vector (0, 0, 1) */
export const NORTH_VECTOR3 = new Vector3(0, 0, -1)

/** North-West direction vector (-√2/2, 0, √2/2) */
export const NORTH_WEST_VECTOR3 = new Vector3(-SQRT1_2, 0, -SQRT1_2)

/** West direction vector (-1, 0, 0) */
export const WEST_VECTOR3 = new Vector3(-1, 0, 0)

/** South-West direction vector (-√2/2, 0, -√2/2) */
export const SOUTH_WEST_VECTOR3 = new Vector3(-SQRT1_2, 0, SQRT1_2)

/**
 * Array containing all 8 cardinal and diagonal direction vectors.
 * All vectors are normalized and have y = 0 (for XZ plane).
 */
const eightDirectionCurrents: ReadonlyArray<Vector3> = [
  SOUTH_VECTOR3,
  SOUTH_EAST_VECTOR3,
  EAST_VECTOR3,
  NORTH_EAST_VECTOR3,
  NORTH_VECTOR3,
  NORTH_WEST_VECTOR3,
  WEST_VECTOR3,
  SOUTH_WEST_VECTOR3,
] as const

if (DEV) {
  freeze(eightDirectionCurrents)
}

export default eightDirectionCurrents
